import { CreateAccountFromTemplateForm } from '../types'

export const getCreateAccountFromTemplateDefaultValues = (): CreateAccountFromTemplateForm => ({
  accountNumber: null,
  baseAccountId: '',
  description: '',
  name: '',
})
